import { createSlice } from "@reduxjs/toolkit"

export const initialUserState = {
    user: {},
    token: "",
    loginForm: {
        username: "",
        password: "",
        error: ""
    },
    registerForm: {
        name: "",
        username: "",
        email: "",
        password: "",
        retype: "",
        error: ""
    },
    resetForm: {
        email: "",
        newPassword: "",
        retypePassword: "",
        error: "",
    },
    signedIn: false,
    loading: false
}

export const userSlice = createSlice({
    name: 'user',
    initialState: initialUserState,
    reducers: {
        updateLoginForm: (state, action) => {
            state.loginForm[action.payload.field] = action.payload.value
        },
        updateRegisterForm: (state, action) => {
            state.registerForm[action.payload.field] = action.payload.value
        },
        updateResetForm: (state, action) => {
            state.resetForm[action.payload.field] = action.payload.value
        },
        loginSuccess: (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
            state.token = action.payload.token
            state.signedIn = true;
        },
        loginFailure: (state, action) => {
            state.loading = false;
            state.loginForm.error = action.payload
        },
        registerSuccess: (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.signedIn = true;
        },
        registerFailure: (state, action) => {
            state.loading = false;
            state.registerForm.error = action.payload
        },
        resetSuccess: (state, action) => {
            state.loading = false;
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.signedIn = true;
        },
        resetFailure: (state, action) => {
            state.loading = false;
            state.resetForm.error = action.payload
        },
        signOut: (state) => {
            state.loading = false;
            state.user = {}
            state.token = ""
            state.signedIn = false
        },
        setUserLoading: (state) => {
            state.loading = true;
        }
    }
})

export const { 
    updateLoginForm,
    updateRegisterForm,
    updateResetForm,
    loginSuccess,
    loginFailure,
    registerSuccess,
    registerFailure,
    resetSuccess,
    resetFailure,
    signOut,
    setUserLoading
} = userSlice.actions;

export default userSlice.reducer;